import React from 'react';
import { Instagram } from 'lucide-react';
const instagramAccounts = [{
  handle: '@Nicolcabelloa',
  url: 'https://instagram.com/nicolcabelloa'
}];
export function Footer() {
  return <footer className="bg-brand-charcoal text-brand-cream py-12" data-id="element-39" data-mp="32o4bgbnxya72">
      <div className="container mx-auto px-6 md:px-12" data-id="element-40" data-mp="32pp39tivff18">
        <div className="border-b border-brand-cream/10 pb-8 mb-8 flex flex-col md:flex-row md:items-end md:justify-between gap-8" data-id="element-41" data-mp="36ooaxlvzlpwd">
          <div className="text-center md:text-left" data-id="element-42" data-mp="3uftn9r2py01x">
            <h2 className="text-3xl font-serif font-semibold tracking-wide mb-2" data-id="element-43" data-mp="398zcg7yn894">
              nicolskincare
            </h2>
            <p className="text-brand-cream/60 font-light text-sm" data-id="element-44" data-mp="3ldkcd03jg4o0">
              Skincare coreano & Comunidad Glow Up
            </p>
          </div>

          <div className="flex flex-col items-center md:items-end gap-3" data-id="element-45" data-mp="29z6v4e3aingy">
            <p className="text-brand-cream/50 font-light text-xs uppercase tracking-widest" data-id="element-46" data-mp="2a19tpmiidoxa">
              Sígueme
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3" data-id="element-47" data-mp="3l9ad1hhfl23w">
              {instagramAccounts.map(account => <a key={account.handle} href={account.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-brand-cream/20 text-sm font-light hover:bg-brand-cream/10 hover:border-brand-cream/40 transition-colors" data-id="element-48" data-mp="3gaz3l7v1stm7">
                  <Instagram size={16} className="text-brand-sage" data-id="element-49" data-mp="82qsptubnvu9" />
                  {account.handle}
                </a>)}
            </div>
          </div>
        </div>

        <p className="text-center md:text-left text-xs text-brand-cream/40 font-light leading-relaxed mb-8" data-id="element-50" data-mp="31upzjlpifqf">
          #RimanMall #RimanChile #Riman #RimanSkincare #Incellderm
          #SkincareCoreano #KBeautyChile #GlowCoreaUGC #NicolCabello — Riman
          Mall Chile: compra skincare coreano RIMAN online con asesoría
          personalizada.
        </p>

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-brand-cream/50 font-light" data-id="element-51" data-mp="msxzvdevpsfn">
          <p data-id="element-52" data-mp="twxuvjrohse2">
            © {new Date().getFullYear()} nicolskincare. Todos los derechos
            reservados.
          </p>
          <p className="flex items-center gap-1" data-id="element-53" data-mp="13tan0d7kry6p">
            Hecho con <span className="text-brand-sage" data-id="element-54" data-mp="13rpsuop6ah9d">💚</span> en Chile
          </p>
        </div>
      </div>
    </footer>;
}